import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './style.css';

export default function SideBar() {
  const location = useLocation();

  return (
    <>
      <nav className={'sidebar open'}>
        <ul>
          <li className={location.pathname === `/registrationRequests` ? 'selected' : ''}>
            <Link to={`/registrationRequests`}>Richieste di registrazione</Link>
          </li>
          <li className={location.pathname === `/companies` ? 'selected' : ''}>
            <Link to={`/companies`}>Lista attività registrate</Link>
          </li>
          <li className={location.pathname.startsWith(`/orders`) ? 'selected' : ''}>
            <Link to={`/orders`}>Lista ordini</Link>
          </li>
          <li className={location.pathname.startsWith(`/topups`) ? 'selected' : ''}>
            <Link to={`/topups`}>Lista ricariche</Link>
          </li>
        </ul>
      </nav>
    </>
  );
}
